import { render, staticRenderFns } from "./DuplicatedPatientSelectorDialog.vue?vue&type=template&id=03c671b3&scoped=true&"
import script from "./DuplicatedPatientSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./DuplicatedPatientSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatedPatientSelectorDialog.vue?vue&type=style&index=0&id=03c671b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c671b3",
  null
  
)

export default component.exports